import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OrderPayments {
  constructor($scope, OrderPaymentService) {
    function open_dialog(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    }

    function load_order_payments() {
      $scope.loading_order_payments = true;
      OrderPaymentService.get_order_payments(window.order.id).success(function(data) {
        if (data.success) {
          $scope.order_payments = data.order_payments;
          $scope.loading_order_payments = false;
        }
      });
    }

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.add_order_payment = function() {
      $scope.dialog_payment = angular.copy(window.order_payment);
      open_dialog('order_payment_dialog');
    };

    $scope.edit_order_payment = function(payment) {
      $scope.dialog_payment = payment;
      open_dialog('order_payment_dialog');
    };

    $scope.delete_order_payment = function(payment) {
      if (confirm('Are you sure you want to delete this order payment?')) {
        OrderPaymentService.delete(payment.id).success(function(data) {
          if (data.success) {
            load_order_payments();
          }
        });
      }
    };

    $scope.save_order_payment = function() {
      $scope.saving_order_payment = true;
      OrderPaymentService.save($scope.dialog_payment).success(function(data) {
        if (data.success) {
          $scope.saving_order_payment = false;
          $.fancybox.close();
          load_order_payments();
        }
      });
    };

    $scope.get_payment_type_title = function(payment_type) {
      if (!payment_type)
        return null;
      else
        return _.findWhere($scope.order_payment_types, {
          id: payment_type
        }).title;
    };

    $scope.get_payment_status_title = function(status) {
      if (!status)
        return null;
      else
        return _.findWhere($scope.order_payment_statuses, {
          id: status
        }).title;
    };

    $scope.init = function() {
      $scope.order_payment_types = window.order_payment_types;
      $scope.order_payment_statuses = window.order_payment_statuses;
      load_order_payments();
    };

    $scope.init();
  }
}

OrderPayments.$inject = ['$scope', 'OrderPaymentService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-payments.ctrl.js